import { Language } from '../models/localization';
import { from, Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';

export class LocalizationService {
	private _currentLanguage: string;

	constructor() {
		this._currentLanguage = document.body.getAttribute('data-language-long') || 'de-CH';
	}

	getAllLanguages(): Observable<Language[]> {
		return this.getUrl().pipe(
			switchMap(url => from(fetch(url))),
			switchMap(res => res.json()),
			shareReplay(1)
		);
	}

	getCurrentLanguage(): string {
		return this._currentLanguage;
	}

	private getUrl(): Observable<string> {
		return from(fetch('/connect/client/config')).pipe(
			switchMap(res => res.json()),
			map(config => `${config.localizationEndpoint}languages`)
		);
	}
}
